<template>
  <v-row justify="center">
    <v-dialog
      v-model="showDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Revoke Monthly Service Charge Bypass</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <div class="text-body-1 mb-2">
                  You are about to revoke the service charge bypass for:
                </div>
                <div class="text-h6 primary--text mb-4">
                  {{ user.name }}
                </div>
                <v-list dense>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="error">
                        {{ icons.mdiAlertCircle }}
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-wrap">The bypass will be immediately deactivated</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="error">
                        {{ icons.mdiAlertCircle }}
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-wrap">Future payments will include monthly service charge deductions again</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="error">
                        {{ icons.mdiAlertCircle }}
                      </v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-wrap">Any unpaid monthly service charges will be deducted from the next payment</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog()"
          >
            Cancel
          </v-btn>
          <v-btn
            color="error"
            text
            :loading="isLoading"
            @click="revokeBypass()"
          >
            Confirm & Revoke Bypass
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from 'axios'
import { mdiAlertCircle } from '@mdi/js'

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    isLoading: false,
    icons: {
      mdiAlertCircle,
    },
  }),
  methods: {
    closeDialog() {
      this.$emit('close')
    },
    revokeBypass() {
      this.isLoading = true
      axios
        .post('users-revoke-monthly-service-charge-bypass', {
          user_id: this.user.id,
        })
        .then(response => {
          this.$notification.success(response.data.message || 'Service charge bypass revoked successfully')
          this.$emit('close')
          this.$emit('bypass-revoked')
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          this.$notification.error(error.response?.data?.message || 'Failed to revoke service charge bypass')
        })
    },
  },
}
</script>
